module.exports = __webpack_public_path__ + "img/amar.cabd64de.png";